<app-horizontal-scroll>

  <a [routerLink]="getDetailViewUrl(movie)" *ngFor="let movie of movies">
    <div *ngIf="movie.idInStore" class="cm-item-container">
      <div class="cm-image-container">
        <img [alt]="movie.title" class="cm-item-image" [src]="getImageUrl(movie)">

        <ng-container *ngIf="movie._inWishlist">
          <div class="wishlist-indicator"></div>
          <img alt="" class="wishlist-star-indicator" src="./assets/images/star_filled_blue.png">
        </ng-container>

        <div *ngIf="movie._inOwnlist" class="purchased-icon">{{getString('purchased')}}</div>

        <!-- Blocked badge oben links -->
        <div class="blocked-badge" *ngIf="movie._inBlocklist" [class.has-owned]="movie._inOwnlist">
          <span class="material-icons blocked-icon">block</span><span>{{getString('blocked')}}</span>
        </div>

        <!-- Quick actions bar on hover -->
        <div class="quick-actions-bar">
          <div class="quick-action" [class.active]="movie._inWishlist" (click)="toggleWishlist($event, movie)">
            <img alt="" [src]="movie._inWishlist ? './assets/images/star_filled_blue.png' : './assets/images/star_filled_black.png'">
            <span class="action-label">{{getString('wishlist')}}</span>
          </div>
          <div class="quick-action" [class.active]="movie._inOwnlist" (click)="toggleOwnlist($event, movie)">
            <img alt="" src="./assets/images/my_purchases_check.png">
            <span class="action-label">{{getString('purchased')}}</span>
          </div>
        </div>
      </div>

      <div class="cm-footer">
        <div class="cm-ratings-container">
          <app-ratings *ngIf="movie.imdbRating || movie.tomatoesScore"
            [imdbRating]="movie.imdbRating"
            [tomatoesRating]="movie.tomatoesScore">
          </app-ratings>
        </div>
        <div class="cm-price-container">
          <app-grid-item-prices [item]="movie" [priceHint]="'offerslist'"></app-grid-item-prices>
        </div>
      </div>
    </div>
  </a>

</app-horizontal-scroll>
